export default "__VITE_ASSET__DcbWOrDk__"